/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {EmailStepError} from './types';

import i18n from '../i18n';

export function translateEmailStepError(
    error: string | EmailStepError | null | undefined,
    generalError: boolean,
    includeStepLabel?: boolean
): string | null {
    if (!error) return null;
    if (typeof error === 'string') {
        if (error === 'invoice_attachment')
            if (generalError)
                return i18n.t(
                    'util.bolValidation.invoiceAttachmentGeneral',
                    'Eén of meer e-mails bevat niet de factuur als bijlage, volgens het beleid van Bol moet de factuur als bijlage meegezonden worden. Het kan zijn dat Bol deze e-mails blokkeert en je loopt het risico op beleidspuntenaftrek.'
                );
            else
                return i18n.t('util.bolValidation.invoiceAttachment', 'Deze e-mail bevat niet de factuur als bijlage.');
        else if (error === 'duplicate_mail')
            if (generalError)
                return i18n.t(
                    'util.bolValidation.duplicateMailGeneral',
                    'Er worden meerdere e-mails naar dezelfde klanten verzonden, volgens het beleid van Bol mag iedere klant maar één e-mail ontvangen. Het kan zijn dat Bol deze e-mails blokkeert en je loopt het risico op beleidspuntenaftrek.'
                );
            else
                return i18n.t(
                    'util.bolValidation.duplicateMail',
                    'Er wordt al een andere e-mail naar deze klanten verzonden. Stuur maximaal 1 mail per 1 order.'
                );
    } else {
        if (error.reason === 'content')
            return includeStepLabel
                ? i18n.t('util.bolValidation.prefixedError', '{{step}}: {{error}}', {
                      step: error.step_label,
                      error: error.error
                  })
                : error.error;
        else if (error.reason === 'overlap') {
            const overlapMsg = i18n.t(
                'util.bolValidation.overlap',
                "Deze e-mail heeft overlap met e-mail '{{step2}}'. Stuur maximaal 1 mail per 1 order",
                {step2: error.step2_label}
            );
            return includeStepLabel
                ? i18n.t('util.bolValidation.prefixedError', '{{step}}: {{error}}', {
                      step: error.step1_label,
                      error: overlapMsg
                  })
                : overlapMsg;
        }
    }
    return null;
}
